import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import InterneKlachtenForm from "./InterneKlachtenForm";
import KlachtBevestigingForm from "./KlachtBevestigingForm";
import AutoBindComponent from "../common/AutoBindComponent";
import Section from "../common/Section";
import redirector from "../../util/redirector";
import InterneKlachtenPageHelper from "./InterneKlachtenPageHelper";
import * as FilesHelperUtil from "../common/FilesHelperUtil";
import * as ajaxActions from "../../actions/ajaxCounterActions";

class InterneKlachtenPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            klachtenModel: {
                id: null,
                voornaam: "",
                achternaam: "",
                klachtenOntvanger: "",
                organisatie: "",
                telefoon: "",
                gsm: "",
                email: "",
                bevestigEmail: "",
                datum: "",
                omschrijving: "",
                klachtenBron: 121450000,
				adres: {
					id: null,
					adresObjectId: null,
					displayName: "",
					gemeenteId: "",
					gemeente: "",
					postCode: "",
					straatId: 0,
					straatNaam: "",
					huisNummer: "",
					busNummer: "",
					latitude: null,
					longitude: null
				}
			},
            klachtenBijlage: [],
            hasUnsavedDocumentChanges: false,
            fileSessionId: null,
            errors: [],
            klachtSent: false
        };

        this.filesHelper = null;
        this.pageHelper = new InterneKlachtenPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    handleOnChange = (event) => this.pageHelper.change(event);
    handleOnSave = () => this.pageHelper.save();
    handleOnDropFile = (propertyName, files) => this.pageHelper.addBijlage(FilesHelperUtil.onDropFiles(this.state[propertyName], propertyName, files));
    handleOnRemoveFile = (propertyName, fileName) => this.pageHelper.removeBijlage(FilesHelperUtil.onRemoveFile(this.state[propertyName], propertyName, fileName));
	handleOnAdresSave = (adres) => this.pageHelper.saveAdres(adres);

    render() {
        if (!!this.filesHelper === false) return null;

        return (
            <Section>
                {this.state.klachtSent ?
                    <KlachtBevestigingForm /> :
                    <InterneKlachtenForm
                        klachtenModel={this.state.klachtenModel}
                        onAdresSave={this.handleOnAdresSave}
                        klachtenBronnen={this.props.klachtenBronnen}
                        onChange={this.handleOnChange}
                        onSave={this.handleOnSave}
                        onDropFiles={this.handleOnDropFile}
                        onRemoveFile={this.handleOnRemoveFile}
                        fileDownloadUrl={this.filesHelper.getFileDownloadUrl()}
                        filesComponent={this.state.klachtenBijlage}
                        errors={this.state.errors}
                    />
                }
            </Section>
        );
    }
}

InterneKlachtenPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        klachtenBronnen: state.referentie.klachtenBronnen
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InterneKlachtenPage);
